"use client"

import React from "react";
import { Collapse as ACollapse } from "antd";
import { FaCaretRight } from "react-icons/fa6";
import { mapModifiers } from "@/utils/funtion";
interface ICollapseProps {
  items: any[];
  accordion?: boolean
  defaultActiveKey?: string[]
}

const Collapse: React.FC<ICollapseProps> = ({ items, accordion, defaultActiveKey }) => {
  return (
    <ACollapse 
      items={items} 
      accordion={accordion} 
      defaultActiveKey={defaultActiveKey} 
      expandIcon={({ isActive }) => <FaCaretRight style={{transform: isActive ? "rotate(90deg)" : "rotate(0)"}} />}
      className={mapModifiers('a-collapse')}
    />
  );
};

export default Collapse;
